import { customElement } from 'lit/decorators/custom-element.js';
import { AbstractStandardTimelineView } from '../abstract-standard-timeline.view';
import type { TimelineViewConfig } from '../_shared/timeline-view.config';

const VIEW_CONFIG: TimelineViewConfig = {
    entityType: 'Employee',
    sort: { strategy: 'property', path: 'lastName', direction: 'ASC' },
    yItemPath: 'employees[*].uid',
    includes: ['employees', 'project', 'keywords', 'creator', 'employeeToIssueAssignments']
};

/**
 * Timeline view grouping issues by assigned employee.
 * Route: /by-assignee
 *
 * Y-axis: Employee — uses default populateTemplateFromYAxis (Employee lookup).
 */
@customElement('o2d-assignees-view')
export class AssigneesView extends AbstractStandardTimelineView {
    protected readonly viewStateName = 'assignees';
    protected readonly viewConfig = VIEW_CONFIG;
}

declare global {
    interface HTMLElementTagNameMap {
        'o2d-assignees-view': AssigneesView;
    }
}
